import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-location-address',
  standalone: true,
  templateUrl: '../../assets/location-address.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamLocationAddressIcon {}
